import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScanComponent } from './scan.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { MatMenuModule } from '@angular/material/menu';
import { CredentialsModule } from '../credentials/credentials.module';
import { MatIconModule } from '@angular/material/icon';
import { ScanRoutingModule } from './scan-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@NgModule({
  declarations: [ScanComponent],
  imports: [
    CommonModule,
    ScanRoutingModule,
    ZXingScannerModule,
    MatMenuModule,
    CredentialsModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
  ],
})
export class ScanModule {}
